import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, r2, r5, rx, sImaginary) {
  var result = Complex.createComplex(0, (sImaginary * r5 * c1 * rx) / r2).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexRParallel, r2) {
  var complexR2 = Complex.createComplex(r2, 0);
  var result = complexRParallel.divide(complexR2);
  return result;
}
